// import React from 'react';
// import '../../assets/css/theme.css';

// const GlobalLoader = () => {
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-70">
//       <div className="w-12 h-12 border-4 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
//     </div>
//   );
// };

// export default GlobalLoader;
import React from 'react';
import '../../assets/css/theme.css';

const GlobalLoader = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="w-10 h-10 border-4 border-[var(--primary)] border-t-transparent rounded-full animate-spin" />
    </div>
  );
};

export default GlobalLoader;
